import { moveMethods } from './move'
import { getCheckedKeys } from './check'
import { contains, flatten, getNonLeafKeys, getPath } from './_util'

function createTreeNodes(rawNodes, treeMap, levelTreeMap, nodeProto, getChildren, parent = null, level = 0) {
  const treeNodes = []

  for (let i = 0; i < rawNodes.length; i++) {
    const rawNode = rawNodes[i]
    const node = Object.create(nodeProto)
    node.rawNode = rawNode
    node.parent = parent
    node.level = level
    node.index = i
    node.isFirstChild = i === 0
    node.isLastChild = i === rawNodes.length - 1
    const rawChildren = getChildren(rawNode)
    if (Array.isArray(rawChildren)) {
      node.children = createTreeNodes(rawChildren, treeMap, levelTreeMap, nodeProto, getChildren, node, level + 1)
    }
    treeNodes.push(node)
    treeMap.set(node.key, node)
    levelTreeMap.set(level, [...(levelTreeMap.get(level) || []), node])
  }
  return treeNodes
}

export function createTreeStore(rawNodes, options = {}) {
  const { ignoreEmptyChildren = false, childrenField = 'children', keyField = 'key' } = options
  const treeMap = new Map()
  const levelTreeMap = new Map()
  const getChildren = ignoreEmptyChildren
    ? (node) => {
        const children = node[childrenField]
        return children && children.length > 0 ? children : null
      }
    : (node) => {
        return node[childrenField]
      }
  const nodeProto = Object.assign(
    {
      get key() {
        return this.rawNode[keyField]
      },
      get disabled() {
        return this.rawNode.disabled || false
      },
      get isLeaf() {
        const isLeaf = this.rawNode.isLeaf
        if (isLeaf !== undefined) return isLeaf
        const children = getChildren(this.rawNode)
        return !children || !children.length
      },
      contains(node) {
        return contains(this, node)
      }
    },
    moveMethods
  )

  const treeNodes = createTreeNodes(rawNodes, treeMap, levelTreeMap, nodeProto, getChildren)

  function getNode(key) {
    if (key === undefined || key === null) return null
    const node = treeMap.get(key)
    return node || null
  }

  const treeStore = {
    treeNodes,
    treeMap,
    levelTreeMap,
    getChildren,
    maxLevel: Math.max(...(levelTreeMap.keys() || [])),
    getFlattenedNodes: (expandedKeys) => flatten(treeNodes, expandedKeys),
    getNode,
    getNonLeafKeys() {
      return getNonLeafKeys(treeNodes)
    },
    getPath(key, options) {
      return getPath(key, options, treeMap)
    },
    getCheckedKeys(checkedKeys, indeterminateKeys, options = {}) {
      const { cascade = true, checkStrategy = 'all', leafOnly = false } = options
      return getCheckedKeys(
        {
          checkedKeys,
          indeterminateKeys,
          cascade,
          checkStrategy,
          leafOnly
        },
        treeStore
      )
    },
    check(keysToCheck, checkedKeys, indeterminateKeys, options = {}) {
      const { cascade = true, checkStrategy = 'all', leafOnly = false } = options
      return getCheckedKeys(
        {
          checkedKeys,
          keysToCheck,
          indeterminateKeys,
          cascade,
          checkStrategy,
          leafOnly
        },
        treeStore
      )
    },
    uncheck(keysToUnCheck, checkedKeys, indeterminateKeys, options = {}) {
      const { cascade = true, checkStrategy = 'all', leafOnly = false } = options
      return getCheckedKeys(
        {
          checkedKeys,
          keysToUnCheck,
          indeterminateKeys,
          cascade,
          checkStrategy,
          leafOnly
        },
        treeStore
      )
    }
  }

  return treeStore
}



// WEBPACK FOOTER //
// ./src/layout/components/tree/tree-store/create.js